import { css, media, tokens } from '@sail/ui';
import { helmTokens } from '../../theme';
export const styles = {
    siteHeader: css({
        position: 'relative',
        zIndex: '100',
        backgroundColor: 'surface',
        ':after': {
            content: '""',
            position: 'absolute',
            bottom: '0',
            left: '0',
            width: '100%',
            height: '1px',
            margin: '0',
            border: 'none',
            backgroundImage: `linear-gradient(90deg,${helmTokens.color.gridLines.dashed},${helmTokens.color.gridLines.dashed} 50%,transparent 0,transparent)`,
            backgroundSize: '8px 1px'
        }
    }),
    siteHeaderGridLinesContainer: css({
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        overflow: 'hidden'
    }),
    siteHeaderContainer: css({
        position: 'relative',
        alignX: 'center',
        maxWidth: `calc((${tokens.space.medium} * 2) + 1080px)`,
        margin: '0 auto',
        paddingX: 'medium'
    }),
    siteHeaderNavContainer: css({
        stack: 'x',
        distribute: 'space-between',
        alignY: 'center',
        minHeight: '56px',
        paddingX: 'medium',
        paddingY: 'space.150',
        [media.down(tokens.viewport.medium)]: {
            paddingTop: 'xlarge'
        }
    }),
    siteHeaderLogo: css({
        margin: '0',
        [media.query('(pointer: fine)')]: {
            transition: `opacity ${helmTokens.transition.hover}`,
            ':hover': {
                opacity: 0.6
            }
        }
    }),
    siteHeaderLogoLink: css({
        display: 'block',
        padding: '4px',
        margin: '-4px',
        lineHeight: '25px'
    })
};

//# sourceMappingURL=SiteHeaderStyles.js.map